import * as ast from "./mscript-ast.js";
import * as lang from "./mscript-lang.js";

function escapeStringValue(value) {
    return String(value || '').replaceAll('!', '!!').replaceAll("'", "!'");
}

function compileLiteral(node) {

    switch (node.type) {
        case lang.TYPE_BOOL:
            return node.value ? 'true' : 'false';
        case lang.TYPE_NULL:
            return 'null';
        case lang.TYPE_INT:
        case lang.TYPE_FLOAT:
        case lang.TYPE_DECIMAL:
            return String(node.value);
        case lang.TYPE_STRING:
        case lang.TYPE_TEXT:
            return `'${escapeStringValue(node.value)}'`;
        case lang.TYPE_SYMBOL:
            return `!${node.value}`;
        case lang.TYPE_UTC_DATETIME:
        case lang.TYPE_ZONED_DATETIME:
        case lang.TYPE_LOCAL_DATETIME:
        case lang.TYPE_LOCAL_DATE:
        case lang.TYPE_LOCAL_TIME:
            return compileDateTimeLiteral(node.value);
        default:
            throw new Error(`Unsupported literal type '${node.type}'`);
    }

}

function compileDateTimeLiteral(value) {

    if (!value)
        throw new Error('Invalid datetime literal value');

    let result = '!';

    if (value.date)
        result += value.date;

    if (value.time) {
        const timeText = value.time.replaceAll(':', '.');
        result += value.date ? `T${timeText}` : timeText;
    }

    if (value.zone) {
        if (value.zone === 'Z') {
            result += 'Z';
        } else {
            result += value.zone.replace(':', '.');
        }
    }

    return result;

}

function compileExpr(node) {

    if (!node)
        return '';

    switch (node.nodetype) {
        case ast.NODE_LITERAL:
            return compileLiteral(node);
        case ast.NODE_IDENT:
            return node.name;
        case ast.NODE_FUNC_CALL:
            return `${node.name}(${(node.args || []).map(compileExpr).join(',')})`;
        case ast.NODE_UN_OP:
        case ast.NODE_BIN_OP:
        case ast.NODE_TERN_OP:
            return `${node.op}(${(node.args || []).map(compileExpr).join(',')})`;
        case ast.NODE_ORDER:
            return `${node.ident}${node.direction === 'desc' ? '-' : ''}`;
        case ast.NODE_QUERY:
            return compileQuery(node);
        default:
            throw new Error(`Unsupported AST node '${node.nodetype}'`);
    }

}

function compileQuery(node, options = {}) {

    const {
        compileFilter = true,
        compileOrder = true,
        compileLimit = true,
        compileOffset = true,
    } = options;

    const parts = [];

    if (compileFilter && node.filter)
        parts.push(`$filter=${compileExpr(node.filter)}`);

    if (compileOrder && node.order && node.order.length)
        parts.push(`$order=${node.order.map(compileExpr).join(',')}`);

    if (compileOffset && node.offset !== null && node.offset !== undefined)
        parts.push(`$offset=${node.offset}`);

    if (compileLimit && node.limit !== null && node.limit !== undefined)
        parts.push(`$limit=${node.limit}`);

    return parts.join('&');

}

export class QScriptCompiler {

    static create() {
        return new QScriptCompiler();
    }

    compile(node, options = {}) {
        if (!node)
            return null;
        if (node.nodetype === ast.NODE_QUERY)
            return compileQuery(node, options);
        return compileExpr(node);
    }

}
